import { render, staticRenderFns } from "./chatMessage.vue?vue&type=template&id=3ad7d989&scoped=true&"
import script from "./chatMessage.vue?vue&type=script&lang=js&"
export * from "./chatMessage.vue?vue&type=script&lang=js&"
import style0 from "./chatMessage.vue?vue&type=style&index=0&id=3ad7d989&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad7d989",
  null
  
)

export default component.exports